import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Dialog from 'client/components/aria/Dialog/Dialog';
import Alert from 'client/components/ui/Alert/Alert';
import SearchField from 'client/components/aria/SearchField/SearchField';
import Button from 'client/components/aria/Button/Button';

import styles from './ShareDialog.module.scss';

const ShareDialog = ({
    isOpen,
    setIsOpen,
    title,
    url,
    restrictedLink,
    ...props
}) => {
    const intl = useIntl();
    const handleOnShare = () => {
        navigator.clipboard.writeText(url);
        setIsOpen(false);
    };

    const handleClose = () => setIsOpen(false);

    return <>
        <Dialog
            isOpen={isOpen}
            onClose={handleClose}
            isDismissable
            role={'alertdialog'}
            aria-labelledby={'share.dialog.title'}
            {...props}
        >
            <Alert role="document">
                <h2 className={[styles.title, 'govuk-error-summary__title'].join(' ')} id="share.dialog.title">
                    {intl.formatMessage({ id: 'dialog.share' }) + title}
                </h2>
                {
                    restrictedLink
                        ? <span className="govuk-caption-m govuk-!-text-align-centre">
                            {intl.formatMessage({ id: 'dialog.restrictedLink' })}
                        </span>
                        : null
                }
                <div className="govuk-grid-row">
                    <div className={['govuk-grid-column-full', styles.copy].join(' ')}>
                        <SearchField
                            aria-label={intl.formatMessage({ id: 'dialog.link' })}
                            defaultValue={url}
                            isReadOnly
                            className={styles.input}
                        />
                        <div className={['govuk-grid-column-one-third', styles.button].join(' ')}>
                            <Button
                                onPress={handleOnShare}
                                data-testid={props['data-testid'] ? props['data-testid'] + '-copy-button' : null}
                            >
                                {intl.formatMessage({ id: 'dialog.copy' })}
                            </Button>
                            <Button
                                variant="error"
                                onPress={handleClose}
                                data-testid={props['data-testid'] ? props['data-testid'] + '-close-button' : null}
                            >
                                {intl.formatMessage({ id: 'close' })}
                            </Button>
                        </div>
                    </div>
                </div>
            </Alert>
        </Dialog>
    </>;
};

ShareDialog.propTypes = {
    isOpen: PropTypes.bool,
    restrictedLink: PropTypes.bool,
    setIsOpen: PropTypes.func,
    url: PropTypes.string,
    title: PropTypes.string,
    'data-testid': PropTypes.string
};

ShareDialog.defaultProps = {
    isOpen: false,
    restrictedLink: false,
    setIsOpen: () => null,
    title: ''
};
export default ShareDialog;
